import { styled } from 'styled-components';
import { Row } from 'components/Base/Grid';

export const SRow = styled(Row)`
  margin-right: 120px;
  margin-bottom: ${({ theme }) => theme.marginSm}px;
`;
